module.exports = __webpack_public_path__ + "media/images/flags/4x3/fsm-0c77bf240d17cbb7256021e251142249.svg";